import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";


const PaymentPurchaseInvoice = ({ payment }) => {
    const { t } = useTranslation("translations");
    const purchaseInvoice=payment?.purchaseInvoice

    const daysRemaining=()=>{
        let today = moment()
        
        let paymentRequestedDate = moment(purchaseInvoice.dueDateTime)
        let daysLeft = paymentRequestedDate.diff(today, 'days')
        return daysLeft
      }
    

    return (
        <>
        <div className="card-body">
        <div className="row">
          <div className="col-md-12 d-flex">
            <div className=" w-100 mb-4">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="supplierInfo"> {t("invoice.suppliersInfo")}</label>
                    <input
                      type="text"
                      name="supplierInfo"
                      id="supplierInfo"
                      className="form-control"
                      value={( purchaseInvoice?.connectionTransactional?.name ?? "") + "," + (purchaseInvoice?.connectionTransactional?.tin ?? "") }
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="docNumber">
                      {t("invoice.docNumber")}
                    </label>
                    <input
                      type="text"
                      name="docNumber"
                      id="docNumber"
                      className="form-control"
                      value={purchaseInvoice?.docNumber ?? ""}
                      onChange={()=>{}}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="supplierInfo">
                      {t("invoice.invoiceDate")}
                    </label>
                    <input
                      type="text"
                      name="invoiceDate"
                      id="invoiceDate"
                      className="form-control"
                      value={moment(purchaseInvoice?.recordDateTime).format("DD/MM/YYYY")  ?? ""}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="daysRemaining">{t("invoice.daysRemain")}</label>
                    <input
                      type="text"
                      name="daysRemaining"
                      id="daysRemaining"
                      className="form-control"
                      value={purchaseInvoice?.dueDateTime?daysRemaining():""}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="cisStatusUnique">FIC</label>
                    <input
                      type="text"
                      name="cisStatusUnique"
                      id="cisStatusUnique"
                      className="form-control"
                      value={purchaseInvoice?.purchaseInvoiceExtracted?.fic ?? ""}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="eicGeneral">EIC</label>
                    <input
                      type="text"
                      name="eicGeneral"
                      id="eicGeneral"
                      className="form-control"
                      value={purchaseInvoice?.eic ?? ""}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="iicGeneral"> {t("invoice.IIC")}</label>
                    <input
                      type="text"
                      name="iicGeneral"
                      id="iicGeneral"
                      className="form-control"
                      value={purchaseInvoice?.purchaseInvoiceExtracted?.iic ?? ""}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="currency"> {t("invoice.currency")}</label>
                    <input
                      type="text"
                      name="currency"
                      id="currency"
                      className="form-control"
                      value={purchaseInvoice?.purchaseInvoiceExtracted?.currency ?? ""}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="amount"> {t("home.amount")}</label>
                    <input
                      type="text"
                      name="amount"
                      id="amount"
                      className="form-control"
                      value={purchaseInvoice?.amount ?? ""}
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>
    );
};

export default PaymentPurchaseInvoice;
